import { UserDatenEingabe } from '../data/user/user-daten-eingabe.model';
import { Betrieb } from '../data/ws/betrieb.model';

export class Functions {
  sortBetriebe(betriebList: Betrieb[]): Betrieb[] {
    return betriebList.sort(this.compareBetrieb);
  }

  sortUserEingabe(userEingabeList: UserDatenEingabe[]): UserDatenEingabe[] {
    return userEingabeList.sort(this.compareUserEingabe);
  }

  compareBetrieb(a: Betrieb, b: Betrieb) {
    if (a.bezeichnung < b.bezeichnung) {
      return -1;
    }
    if (a.bezeichnung > b.bezeichnung) {
      return 1;
    }
    return 0;
  }

  compareUserEingabe(a: UserDatenEingabe, b: UserDatenEingabe) {
    if (a.bezeichnung < b.bezeichnung) {
      return -1;
    }
    if (a.bezeichnung > b.bezeichnung) {
      return 1;
    }
    return 0;
  }
}
